import { IProjectConfiguration } from "../entities-generated/models/project/project-configuration";
import { IProjectSelectionRequest } from "../entities-generated/models/project/project-selection-request";
import { IStormDoorModel } from "../entities-generated/models/storm-door/storm-door-model";
import { ApiClient } from "./shop-api-client";

class ShopStormDoorApiClientClass {
  public getStormDoorOptions(doorInstallationId: string) {
    return ApiClient.get<IStormDoorModel[]>(`shop/install-plans/${doorInstallationId}/storm-doors`);
  }

  public getSelectedStormDoor(doorInstallationId: string) {
    return ApiClient.get<IStormDoorModel>(`shop/install-plans/${doorInstallationId}/storm-doors/selected`);
  }

  public selectStormDoor(request: IProjectSelectionRequest) {
    return ApiClient.patch<IProjectConfiguration>(`shop/storm-doors/select`, request);
  }
}

export const ShopStormDoorApiClient = new ShopStormDoorApiClientClass();